import { render } from "./NewPromotionModal.vue?vue&type=template&id=e380d27c&scoped=true"
import script from "./NewPromotionModal.vue?vue&type=script&lang=js"
export * from "./NewPromotionModal.vue?vue&type=script&lang=js"

import "./NewPromotionModal.vue?vue&type=style&index=0&id=e380d27c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e380d27c"

export default script